<template>
  <div>
      <tplheader></tplheader>
      <tplLeftPanel></tplLeftPanel>
    <form>
      <div id="main-panel" class="main-panel">
        <div class="content-panel">
          <ul class="breadcrumb">
            <li>Kezdőőoldal</li>
            <li>Log</li>
          </ul>
          <div class="page-title">
            <h1><i class="material-icons">chevron_right</i>Log</h1>
          </div>
          <div class="panel">
            <div class="panel-heading">
              <h4>Log</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="panel-sub-heading"><h4>Kereső</h4></div>
                    </div>
                    <div class="col-xs-2">
                      <inputbox id="keyword" :keydownEnter="searchClick" label="Kártya szám / Név / Neptunkód" name="keyword" v-model="search.keyword"></inputbox>
                    </div>
                    <div class="col-xs-1">
                      <inputbox maxlength="8" inputCheck="cardRf" :keydownEnter="searchClick" id="rfid" label="RF ID" name="rfid" v-model="search.rfid"></inputbox>
                    </div>
                    <div class="col-xs-2">
                      <combobox id="type" label="Típus" name="type" v-model="search.type"></combobox>
                    </div>
                    <div class="col-xs-1">
                      <inputbox datepicker="1" id="from" label="dátum -tól" name="from" v-model="search.from"></inputbox>
                    </div>
                    <div class="col-xs-1">
                      <inputbox datepicker="1" id="to" label="dátum -ig" name="to" v-model="search.to"></inputbox>
                    </div>
                    <div class="col-xs-3">
                      <div style="margin-top: 12px">
                        <ajaxLoaderButton :onClick="searchClick" iconclass="fa fa-search" className="btn btn-white" label="Keresés" v-model="searching_in_progress"/>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12">
                  <div v-if="logs.length">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Típus</th>
                        <th>Kártyaszám</th>
                        <th>Kártyabirtokos</th>
                        <th>Létehozva</th>
                        <th>Lefutott</th>
                        <th>Admin</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="log in logs">
                        <td>{{ log.id }}</td>
                        <td>{{ typeDisplay(log.process) }}</td>
                        <td><router-link class="btn btn-white medium" target="_blank" :to="'card/edit/?id='+log.jsondata.card_id">{{ cardNumber(log.jsondata.card_number, log.jsondata.card_type) }}</router-link></td>
                        <td><router-link class="btn btn-white medium" target="_blank" :to="'card_owner/edit/?id='+log.jsondata.card_owner_id">{{ cardOwnerName(log.jsondata.card_owner_name, log.jsondata.card_owner_email) }}</router-link></td>
                        <td>{{ dateTimeFormat(log.created) }}</td>
                        <td>{{ dateTimeFormat(log.executed_time) }}</td>
                        <td>{{ log.admin_name }} ({{ log.admin_email }})</td>
                      </tr>
                    </tbody>
                  </table>
                  <pagination showcombo="1" :limit="query.limit" :amount="query.amount" v-on:pageChanged="pageChanged" v-model="query.page"></pagination>
                  </div>
                  <div v-else>
                    Nem található log.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>
<script>
import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {
      query: {
        keyword: '',
        type: 0,
        rfid: '',
        page: 1,
        limit: 100,
        amount: 0
      },
      search: {
        keyword: '',
        type: {
          items: [
            {
              value: 0,
              label: '- Összes -'
            },
            {
              value: 1,
              label: 'Hallgató kártya aktiválás'
            },
            {
              value: 2,
              label: 'Alkalmazotti kártya aktiválás'
            },
            {
              value: 3,
              label: 'Vendég / Öregdiák kártya aktiválás'
            },
            {
              value: 4,
              label: 'Access level hozzáadás belepteto.sze.hu-n'
            },
            {
              value: 5,
              label: 'Access level visszavonás belepteto.sze.hu-n'
            },
            {
              value: 6,
              label: 'Kártya tiltása / felfüggesztése'
            }
          ],
          selected: 0
        },
        rfid: '',
        from: '',
        to: ''
      },
      searching_in_progress: false,
      logs: []
    }
  },
  watch: {
    '$route': 'routerChange'
  },
  methods: {
    clearSearchFields: function() {
      this.search.keyword = '';
      this.search.type.selected = 0;
      this.search.rfid = '';
      this.search.from = '';
      this.search.to = '';
    },

    watchCardReader: function() {
      if (this.$root.socket.readyState === WebSocket.OPEN) {
        this.$root.socket.close();
      }

      var _this = this;
      try {
        this.$root.socket = new WebSocket("wss://kmr-reader.uninet.hu:8080");

        this.$root.socket.onmessage = function (event) {
          if (event.data != undefined) {
            _this.clearSearchFields();
            _this.search.rfid = event.data;
            _this.searchClick();
          }
        };
      } catch(err) {

      }
    },

    routerChange: function() {
      if (Object.keys(this.$route.query).length != 0) {
        this.query = JSON.parse(JSON.stringify(this.$route.query));
        this.search.keyword = this.query.keyword;
        this.search.type.selected = this.query.type;
        this.search.rfid = this.query.rfid;
        this.search.from = this.query.from;
        this.search.to = this.query.to;

      } else {
        this.query = {
          keyword: '',
          rfid: '',
          type: 0,
          page: 1,
          limit: 100,
          amount: 0,
          from: '',
          to: ''
        };
        this.search.keyword = '';
        this.search.rfid = '';
        this.search.type.selected = 0;
        this.search.from = '';
        this.search.to = '';
      }

      this.getList();
    },

    pageChanged: function(val) {
      this.query.page = val;
      this.$router.push({path: '/log', query: this.query});
    },

    searchClick: function() {
      this.query.page = 1;
      this.query.keyword = this.search.keyword;
      this.query.type = this.search.type.selected;
      this.query.rfid = this.search.rfid;
      this.query.from = this.search.from;
      this.query.to = this.search.to;

      this.$router.push({path: '/log', query: this.query});
    },

    getList: function() {
      var _this = this;

      this.searching_in_progress = true;

      this.$root.ajax('log', {
        data: this.query,
        method: 'POST',
        success: function(response) {
          _this.logs = response.logs;
          _this.query.amount = response.amount;
          _this.searching_in_progress = false;
        }
      });
    },

    typeDisplay(type) {
      var s = '';
      switch (type) {
        case 'ADD_STUDENT_TO_KANCARD':
          s = 'Hallgató kártya aktiválás';
          break;

        case 'ADD_EMPLOYEE_TO_KANCARD':
          s = 'Alkalmazotti kártya aktiválás';
          break;

        case 'ADD_GUEST_TO_KANCARD':
          s = 'Vendég kártya aktiválás';
          break;

        case 'ADD_ACCESS_LEVEL_TO_CARD_ON_BELEPTETO':
          s = 'Access level hozzáadás belepteto.sze.hu-n';
          break;

        case 'REMOVE_ACCESS_LEVEL_FROM_CARD_ON_BELEPTETO':
          s = 'Access level visszavonás belepteto.sze.hu-n';
          break;

        case 'DISABLE_CARD_ON_BELEPTETO':
          s = 'Kártya tiltása / felfüggesztése';
          break;
      }
      return s;
    },

    cardOwnerName(name, email) {
      var s = name;
      if (email != undefined && email != '') {
        s += ' ('+email+')';
      }
      return s;
    },

    cardNumber(card_number, card_type) {
      var s = '';

      if (card_type != undefined && card_type != '') {
        var t = '';
        switch(card_type) {
          case 'O':
            t = 'Öregdiák';
            break;
          case 'H':
            t = 'Hallgató';
            break;
          case 'A':
            t = 'Alkalmazott';
            break;
          case 'G':
            t = 'Vendég';
          case 'V':
            t = 'Kollégiumi vendég';
            break;
          case 'K':
            t = 'Könyvtári tag';
            break;
        }
        s = card_number + ' ('+t+')';

      } else {
        s = card_number;
      }
      return s;
    },

    dateTimeFormat(datetime) {
      if (datetime != null) {
        return moment(datetime).format('YYYY.MM.DD., HH:mm');
      } else {
        return '-';
      }
    }
  },

  created: function() {
    this.routerChange();
    this.watchCardReader();
  },
  mounted: function() {

  }
}
</script>


// WEBPACK FOOTER //
// log.vue?56f4b2a8